<template>
  <div>
    <div class="blue-subhead-bg text-uppercase">
      <h1>Dashboard</h1>
    </div>

    <div class="container admin-users">
      <br>
      <div class="blue-outline-nh light-grey-type">
        <div class="row receipt-row-wrapper">
          <div class="col-sm-4 receipt-details-sec">
            <div class="receipt-details">
              <br>
              {{ user.name || 'N/A'}}<br>
              Invoice/Receipt #{{ receipt.receiptNumber }}<br>
              Date of Purchase: {{ formatDate(receipt.dateOfPurchase) }}<br>
              <ul>
                <li
                  class="receipt-item"
                  v-for="(receiptItem, index) in receipt.receiptItems" :key="index">
                  Item: {{ getRebateItem(receiptItem.item).name }}<br>
                  Points: {{ getRebateItem(receiptItem.item).points }}<br>
                  Quantity: {{ receiptItem.quantity }}<br>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-sm-8 receipt-image-sec">
            <div class="pdf-container" v-if="receiptImageType === 'pdf'">
              <pdf :src="receipt.image.url" class=""></pdf>
            </div>
            <img v-else-if="receiptImageType === 'image'" :src="receipt.image.url" class="img-responsive center-block">
            <img v-else src="../../assets/images/proof-of-purchase.jpg" class="img-responsive center-block">
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <a href="" @click.prevent="back"><strong>Back</strong></a> |
          <a href="#" @click.prevent="approve"><strong>Approve</strong></a> |
          <a href="#" @click.prevent="deny"><strong>Deny</strong></a></div>
        <br>
        <div class="col-sm-6">
          <select v-model="receipt.denialReason" class="form-control admin-form-control input-lg">
            <option :value="''">Denial Options</option>
            <option value="duplicate">Invoice/Receipt Number Already Submitted</option>
            <option value="bad_date">Invalid Date</option>
            <option value="invalid_invoice">Invalid Invoice</option>
            <option value="other">Other</option>
          </select>
        </div>
        <div class="col-sm-7" v-if="receipt.denialReason === 'other'">
          <textarea v-model="receipt.denialReasonOther" class="form-control admin-form-control input-lg" rows="5" placeholder="Denial Reason Other"></textarea>
        </div>
        <div class="col-sm-7">
          <textarea v-model="receipt.adminComments" class="form-control admin-form-control input-lg" rows="5" placeholder="Admin Comments"></textarea>
        </div>
      </div>
      <br><br>
    </div><!-- container-fluid -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import axios from 'axios'
import pdf from 'vue-pdf'

axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')

export default {
  name: 'ReceiptItemDetail',
  props: ['receipt', 'receiptItem'],
  components: {
    pdf
  },
  data () {
    return {
      user: this.receipt.user
    }
  },
  computed: {
    ...mapState('loyaltyProgram', {
      program: state => state.program
    }),
    rebateItems () {
      return this.program.rebateItems
    },
    userLoyaltyProgram () {
      return this.program.userLoyaltyPrograms.find(ulp => ulp._id === this.user.userLoyaltyProgram)
    },
    earnedPoints () {
      const sum = this.receipt.receiptItems.reduce((sum, receiptItem) => {
        const item = this.getRebateItem(receiptItem.item)
        sum += item.points * receiptItem.quantity
        return sum
      }, 0)
      return sum
    },
    receiptImageType () {
      if (this.receipt.image.url !== null && this.receipt.image.url.match(/\.pdf$/)) {
        return 'pdf'
      } else if (this.receipt.image.url !== null) {
        return 'image'
      } else {
        return null
      }
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions('receipt', ['updateReceiptItem', 'approveReceipt', 'denyReceipt']),
    ...mapActions('user', ['updateUserLoyaltyProgram']),
    formatDate (date) {
      return moment(date).format('MM/DD/YYYY').toString()
    },
    approve () {
      this.$bus.emit('global-load', { load: true, message: 'Approving receipt', env: 'client' })
      this.approveReceipt({
        receiptId: this.receipt._id,
        body: {
          points: this.earnedPoints,
          adminComments: this.receipt.adminComments,
          approvalDate: Date.now()
        }
      })
        .then(() => {
          // send email
          return new Promise((resolve, reject) => {
            axios.post(
              `${process.env.VUE_APP_SERVER_HOST}/api/common/mailer/userRebateSubmissionApproved`,
              {
                emailInfo: {
                  to: this.user.email,
                  name: this.user.firstName,
                  points: this.earnedPoints,
                  company: this.program.company.name,
                  slug: this.program.slug
                }
              }
            )
              .then(response => {
                resolve(response)
              })
              .catch(err => {
                reject(err)
              })
          })
        })
        .then((userLoyaltyProgram) => {
          this.$bus.emit('global-load', { load: false })
          this.$router.push({ name: 'UnapprovedRebateSubmissions' })
        })
        .catch((err) => {
          console.log(err)
          this.$bus.emit('global-load', { load: false })
          this.$bus.emit('notify', { message: 'Approval error.', type: 'danger' })
        })
    },
    deny () {
      if (!this.receipt.denialReason) { return alert('Please select a denial reason.') }
      this.denyReceipt({
        receiptId: this.receipt._id
      })
        .then(() => {
          // send email
          return new Promise((resolve, reject) => {
            axios.post(
              `${process.env.VUE_APP_SERVER_HOST}/api/common/mailer/userRebateSubmissionDenied`,
              {
                emailInfo: {
                  to: this.user.email,
                  name: this.user.firstName,
                  denialReason: this.receipt.denialReason,
                  denialReasonOther: this.receipt.denialReasonOther,
                  company: this.program.company.name
                }
              }
            )
              .then(response => {
                resolve(response)
              })
              .catch(err => {
                reject(err)
              })
          })
        })
        .then((userLoyaltyProgram) => {
          this.$router.push({ name: 'UnapprovedRebateSubmissions' })
        })
    },
    getRebateItem (id) {
      return this.rebateItems.find(i => i._id === id)
    },
    back () {
      this.$router.push({ name: 'UnapprovedRebateSubmissions' })
    }
  }
}
</script>

<style scoped>
.receipt-row-wrapper {
  display: flex;
  max-height: 60vh;
}

.receipt-details-sec {
  max-height: 100%;
  display: flex;
  flex-direction: column;
}

.receipt-details {
  overflow-y: auto;
}

.receipt-image-sec {
  display: flex;
  flex-direction: column;
}

.pdf-container {
  flex: 1 1 350px;
  overflow-y: auto;
  border: 1px solid #e3e3e3;
}
</style>
